// extracted by mini-css-extract-plugin
export default {"field":"FieldString__field___n1onQ","label":"FieldString__label___YZl1G","value":"FieldString__value___qr8ho"};